import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.scss';

import Layout from './components/layout/Layout';
import HomePage from './pages/home/HomePage';
import AboutPage from './pages/about/AboutPage';
import ServicesPage from './pages/services/ServicesPage';
import ContactPage from './pages/contact/ContactPage';
import { LanguageProvider } from './contexts/language/LanguageContext';
import { NavbarProvider } from './contexts/navigation/NavbarContext';

const App = () => {
  return (
    <LanguageProvider>
      <NavbarProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="portfolio" element={<HomePage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="services" element={<ServicesPage />} />
              <Route path="contact" element={<ContactPage />} />
              {/* Redirect old routes to portfolio */}
              <Route path="work" element={<Navigate to="/portfolio" replace />} />
              <Route path="modeling" element={<Navigate to="/portfolio" replace />} />
              <Route path="publications" element={<Navigate to="/portfolio" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </NavbarProvider>
    </LanguageProvider>
  );
};

export default App;